export default __webpack_public_path__ + "static/media/individual-selected.8e553f14.svg";